const buildTotalFundInvestmentsExpression = (fundInvestmentSheetNames: string[]) =>
  fundInvestmentSheetNames.length
    ? `=SUM(${fundInvestmentSheetNames.map(fundInvestmentKey => `${fundInvestmentKey}.totalValue`).join(',')})`
    : '';

export default buildTotalFundInvestmentsExpression;
